<style>
</style>
<template>
<v-text-field solo flat persistent-hint
              :hint="hintValue"
              :label="$t(label)"
              v-model="inputValue"
              type="email"
              :required="required"
              :rules="rules"
></v-text-field>
</template>
<script>
import TransformMixin from '../mixins/transform-mixin.js'
export default {
  name: 'setting-email',
  props: {
    name: {
      type: String,
      default: 'title'
    },
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    defaultValue: {
      type: String,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  mixins: [TransformMixin],
  data() {
    return {
      rules: [
        (v) => (!this.required || !!v) || '',
        (v) => (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || this.transform(this.hintValue)
        // (v) => (v.length === 0 || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || this.transform('Neplatný email')
      ]
    }
  },
  computed: {
    inputValue: {
      get() {
        return this.value ? this.value : this.defaultValue
      },
      set(value) {
        this.$emit('input', value)
        // this.$emit('changed', value !== this.defaultValue)
      }
    },
    hintValue: {
      get() {
        return this.transform('email') + (this.required ? ' *' : '')
      }
    }
  },
  methods: {

  }
}
</script>
